<div class="app-dialog">
  <header class="app-dialog__header">
    <div class="app-dialog__header-text">
      <h2>{{ 'signatures.newSignatureHeader' | translate }}</h2>
    </div>
    <button mat-icon-button type="button" (click)="cancel()" [attr.aria-label]="'cancel' | translate">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="app-dialog__body">
    <div class="signature-choice-dialog__options">
      <div class="signature-choice-dialog__option" (click)="chooseGenerator()">
        <mat-icon>auto_fix_high</mat-icon>
        <div class="signature-choice-dialog__option-content">
          <h3>{{ 'signatures.wantToGenerateSignature' | translate }}</h3>
          <p>{{ 'signatures.goToGenerator' | translate }}</p>
        </div>
      </div>

      <div class="signature-choice-dialog__option" (click)="chooseManual()">
        <mat-icon>edit</mat-icon>
        <div class="signature-choice-dialog__option-content">
          <h3>{{ 'signatures.wantToAddManually' | translate }}</h3>
          <p>{{ 'signatures.addNew' | translate }}</p>
        </div>
      </div>
    </div>
  </div>

  <footer class="app-dialog__footer">
    <button mat-stroked-button type="button" (click)="cancel()">
      {{ 'cancel' | translate }}
    </button>
  </footer>
</div>
